function LoadingScreen({ isLeaving }) {
  return (
    <div
      className={`loading-screen ${isLeaving ? 'is-leaving' : ''}`}
      role="status"
      aria-live="polite"
      aria-label="Загрузка сайта Chinatao"
    >
      <div className="loading-card">
        <div className="yin-yang" aria-hidden="true" />
        <div className="loading-copy">
          <span>Chinatao</span>
          <strong>Ваш путь в Китай</strong>
          <p>Собираем маршрут</p>
        </div>
        <div className="loading-line" aria-hidden="true" />
      </div>
    </div>
  );
}

export default LoadingScreen;
